import { DONOR_ID, DONOR_ID_DETAIL, SETISRELOAD, setIsReload,  } from '../../actions/checkin'

const initialState = {
  isReload: false,
};

export const ReloadDonorDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SETISRELOAD:
      return {
        ...state,
        isReload: !state.isReload,
      };
    default:
      return state;
  }
};


const initState = {
  donorId: null,
  donorDetail: null,
}
export const donorIdStateReducer = (state = initState, action = {}) => {
  switch (action.type) {
    case DONOR_ID:
        return { ...state, donorId: action.donorId }
    case DONOR_ID_DETAIL:
        return { ...state, donorDetail: action.donorDetail }
    default:
      return { ...state, ...action }
  }
}